import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { icons } from "../../assets/icons";
import { Heading } from "../../components/Heading/Heading";
import { Panel } from "../../components/Panel/Panel";
import { Section } from "../../components/Section";
import { Text } from "../../components/Text/Text";
import { SectionIds } from "../sectionIds";

const Grid = styled.div`
  @media (min-width: ${(props) => props.theme.screenSize.sm}) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 2rem;
  }
`;

const StyledText = styled(Text)`
  @media (min-width: ${(props) => props.theme.screenSize.sm}) {
    min-height: 2.8rem;
  }
`;

const PanelWrapper = styled.div`
  padding: 1rem 0 1rem 0;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: auto;
  grid-gap: 0.4rem;
  width: 100%;
  margin-bottom: 1rem;

  @media (min-width: ${(props) => props.theme.screenSize.sm}) {
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 0.5rem;
  }

  @media (min-width: ${(props) => props.theme.screenSize.lg}) {
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 0.5rem;
  }
`;

export const Skills = () => {
  const { t } = useTranslation();

  return (
    <Section id={SectionIds.skills} gridCol="1 / 3">
      <Heading stage="03 ─ stack">{t("skills.heading")}</Heading>
      <div style={{ marginBottom: "2rem" }}>
        <div>{t("skills.description")}</div>
      </div>
      <Grid>
        <div>
          <StyledText color="secondary">
            {t("skills.specialization")}
          </StyledText>
          <PanelWrapper>
            <Panel icon={icons.react} title="React" />
            <Panel icon={icons.ts} title="Typescript" />
            <Panel icon={icons.gitlab} title="GitLab CI" />
            <Panel icon={icons.docker} title="Docker" />
            <Panel icon={icons.zustand} title="Zustand" />
            <Panel icon={icons.stencil} title="Stencil" />
            <Panel icon={icons.jest} title="Jest" />
            <Panel icon={icons.webpack} title="Webpack" />
            <Panel icon={icons.sass} title="SCSS" />
            <Panel icon={icons.git} title="Git" />
            <Panel icon={icons.kiro} title="Kiro CLI" />
            <Panel icon={icons.vite} title="Vite" />
          </PanelWrapper>
        </div>
        <div>
          <StyledText color="secondary">{t("skills.additional")}</StyledText>
          <PanelWrapper>
            <Panel icon={icons.nodejs} title="NodeJS" />
            <Panel icon={icons.astro} title="Astro" />
            <Panel icon={icons.graphql} title="GraphQL" />
            <Panel icon={icons.mongodb} title="MongoDB" />
            <Panel icon={icons.mysql} title="MySQL" />
            <Panel icon={icons.js} title="Javascript" />
            <Panel icon={icons.html5} title="HTML5" />
          </PanelWrapper>
        </div>
      </Grid>
    </Section>
  );
};
